/**
 * @enum {string}
 */
export const MainCategories = {
  TRACK: 'TRACK',
  ADVERTISEMENT: 'ADVERTISEMENT',
  PLAYER: 'PLAYER',
  AUTHENTICATE: 'AUTHENTICATE',
  STARTUP: 'STARTUP',
  SWIPE: 'SWIPE',
  RECORDING: 'RECORDING',
  ARTICLE: 'ARTICLE',
  LOG: 'LOG',
};

/**
 * @enum {string}
 */
export const PlayerSubcategories = {
  PLAY_START: 'PLAY_START',
  PLAYING: 'PLAYING',
  PLAY_STOP: 'PLAY_STOP',
  KEEP_ALIVE_ERROR: 'KEEP_ALIVE_ERROR',
  PLAY_STATE: 'PLAY_STATE',
  PLAY_ERROR: 'PLAY_ERROR',
  PLAY_WARNING: 'PLAY_WARNING',
};

/**
 * @enum {string}
 */
export const LogSubcategories = {
  LOG_LOGGING_ERROR: 'LOG_LOGGING_ERROR',
};

/**
 * @enum {string}
 */
export const TrackSubcategories = {
  PAGE_VIEW: 'PAGE_VIEW',
  POPUP: 'POPUP',
};

export const enum POPUP_TYPE {
  CONTINUE_WATCHING = 'CONTINUE_WATCHING',
}

/**
 * @enum {string}
 */
export const PropertyKeys = {
  id: 'id',
  name: 'name',
  programId: 'programId',
  scheduleId: 'scheduleId',
  channelId: 'channelId',
  channelName: 'channelName',
  vodStreamId: 'streamId',
  streamId: 'ssId',
  streamType: 'type',
  manifest: 'manifest',
  timePlayed: 'time',
  episode: 'episode',
  season: 'season',
  referenceId: 'referenceId',
  errorId: 'errorId',
  errorCode: 'errorCode',
  errorMessage: 'errorMessage',
  stackTrace: 'stackTrace',
  originator: 'originator',
  reason: 'reason',
  type: 'type',
};

/**
 * @enum {string}
 */
export const StaticPageUrls = {
  login: 'login',
  videoPlayer: 'videoplayer',
  splash: 'splash',
  vodDetail: 'vod_detail',
  epgDetail: 'epg_detail',
  epgSeriesDetail: 'epg_series_detail',
  bundleDetail: 'bundle_detail',
  recordingDetail: 'recording_detail',
  settings: 'my_stuff_settings',
  epgLists: 'epg_lists',
  epgGuide: 'epg_guide',
  replayEpgLists: 'replay_epg_lists',
  myStuffRecordingsPlanned: 'my_stuff_recordings_planned',
  myStuffRecordingsRecorded: 'my_stuff_recordings_recorded',
  myStuffRecordingsExpired: 'my_stuff_recordings_expired',
};
